export var LoyaltyTransactionSourceTypeEnum;
(function (LoyaltyTransactionSourceTypeEnum) {
    LoyaltyTransactionSourceTypeEnum["ORDER"] = "ORDER";
    LoyaltyTransactionSourceTypeEnum["EARN_RULE"] = "EARN_RULE";
    LoyaltyTransactionSourceTypeEnum["MANUAL"] = "MANUAL";
    LoyaltyTransactionSourceTypeEnum["SYNC"] = "SYNC";
    LoyaltyTransactionSourceTypeEnum["EXPIRATION"] = "EXPIRATION";
})(LoyaltyTransactionSourceTypeEnum || (LoyaltyTransactionSourceTypeEnum = {}));
//# sourceMappingURL=LoyaltyTransactionSourceTypeEnum.js.map